import { render } from "./TransactionContainer.vue?vue&type=template&id=f4d343b8&ts=true"
import script from "./TransactionContainer.vue?vue&type=script&lang=ts"
export * from "./TransactionContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__